import type { PropsWithChildren } from 'react';

import { Typography } from 'antd';
import classNames from 'classnames';

import styles from './Title.module.scss';

const { Text } = Typography;

type TProps = {
  isRequired?: boolean;
  className?: string;
  isDisabled?: boolean;
};

export const Title = ({ children, className, isRequired = false, isDisabled = false }: PropsWithChildren<TProps>) => (
  <div>
    {isRequired && (
      <Text
        type="danger"
        className={styles.required}
      >
        *
      </Text>
    )}
    <Text
      disabled={isDisabled}
      className={classNames(styles.title, className)}
    >
      {children}
    </Text>
  </div>
);
